<template>
  <div class="inherit-height scroll-container">
    <!-- avoid pull-to-refresh by making the container scroll some pixels -->
    <v-card flat
            class="pt-8 px-6 fill-container-inner"
            style="height:calc(100% + 5px) !important">
      <v-card-title class="overline pt-3">
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text class="mt-1"
                   v-if="$slots['content']">
        <slot name="content"></slot>
      </v-card-text>
      <v-card-text class="mt-1"
                   v-for="(row, ind) in numberedTextRows"
                   :key="ind">
        <v-chip class="mr-3">{{ ind + 1 }}</v-chip>
        {{ row }}
      </v-card-text>
      <v-card-text class="mt-1"
                   v-for="(row, ind) in textRows"
                   :key="ind"> {{ row }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
// Component to use for displaying a numbered instruction list or an array of text lines in a flat card
export default {
  props: {
    numberedTextRows: {
      type: Array,
      default: () => [],
    },
    textRows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
